import {
    FormikValues,
    useFormik
} from "formik";
import {
    Grid,
    TextField,
    Typography
} from "@mui/material";

type CustomLinkVariablesFormProps<T extends FormikValues> = {
    formik: ReturnType<typeof useFormik<T>>;
};

export const CustomLinkVariablesForm = <T extends FormikValues>(props: CustomLinkVariablesFormProps<T>) => {
    const { formik } = props;

    return (
        <>
            <Grid item xs={12}>
                <Typography variant="h6">Custom Link Configuration</Typography>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    required
                    fullWidth
                    id="variables.url"
                    name="variables.url"
                    label="URL"
                    value={formik.values.variables?.url || ''}
                    onChange={formik.handleChange}
                    error={Boolean((formik.errors.variables as any)?.url)}
                    helperText={(formik.errors.variables as any)?.url}
                />
            </Grid>
        </>
    );
}; 